import { IScheduleFineAPIState } from "../types/scheduleFine.types";

export const SCHEDULE_FINE_INITIAL_STATE: IScheduleFineAPIState = {
  data: {
    list: [],
    totalPages: 0,
    totalRecords: 0,
  },
  pageProps: {
    isDescending: false,
    pageNumber: 1,
    perPage: 10,
    searchText: "",
    sortingOn: "",
  },
  list: [],
  loading: false,
  error: null,
  currentScreen: "list",
  selectedScheduleFine: null,
  customerFines: [],
};
